import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import * as AspNetData from "devextreme-aspnet-data-nojquery";
import { ClientService, CreditHistoryItem } from 'src/app/services/client.service';
import { ConstantsService } from 'src/app/services/constants.service';

@Component({
  selector: 'app-client-disclaimer-history',
  templateUrl: './client-disclaimer-history.component.html',
  styleUrls: ['./client-disclaimer-history.component.css']
})
export class ClientDisclaimerHistoryComponent implements OnInit, OnChanges {

  @Input() clientId: number = -1;
  dataSource: any;
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  constructor(private clientService: ClientService) {
    let url: string = "/api/Clients/ClientDisclaimerHistory";
    this.dataSource = AspNetData.createStore({
      key: "Id",
      loadUrl: url,
      onBeforeSend: (e, ajax) => {
        ajax = ConstantsService.AddDefaultHeaders(e, ajax);
        ajax.data.ClientId = this.clientId;
      }
    });
  }

  Reset() {
    this.clientId = -1;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.dataGrid && this.dataGrid.instance && this.dataGrid.instance.getDataSource()) {
      this.dataGrid.instance.getDataSource().reload();
    }
  }

  ngOnInit(): void {
  }
}
